import React from 'react'
import mockEdpmsResult from '../data/edpmsResultMock.json';
import CustomForm from './customForm';
import Footer from './footer';
import Carousels from './carousel';
import Navbars from './Navbar';
const CsbToEdpms = () => {

   const handleFormSubmit = async (formData) => {
    try {
      const response = await fetch('/eicimobility/edpmsResult', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
        hawbNo: formData.hawbNo,
        courierName: formData.courierCompany
        }) 
      });
      if (!response.ok) {
        return {
          status: 'FAILURE',
          errorMessage: 'Failed to fetch data from server.',
        };
      }
      const data = await response.json();
      return data; 
    } catch (error) {
      return {
        status: 'FAILURE',
        errorMessage: 'Network error or unexpected issue occurred.',
      };
    }
  };
  return (
     <div className="container-fixed">
      <Navbars />
      <Carousels />
       <CustomForm
      title="Status of Transmission of CSB to RBI-EDPMS"
      onSubmit={handleFormSubmit}
      navigateTo="/edpmsResult"
    />
    < Footer/>
      </div>  
  )
}
export default CsbToEdpms